export const FETCH_PROMOS = 'FETCH_PROMOS';
export const CREATE_PROMO = 'CREATE_PROMO';
export const UPDATE_PROMO = 'UPDATE_PROMO';
export const DELETE_PROMO = 'DELETE_PROMO';
